export const DROPDOWN_OPTIONS = [{ title: "Activate" }, { title: "Deactivate" }];
